export default __webpack_public_path__ + "static/media/contact.7fddf370.svg";